module.exports = __webpack_public_path__ + "resources/img/img_secure_center02.f6194b494d1cb31d97f0d2a7153678e3.png";